import React, { useState, useEffect, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";

import { Button, Dialog } from "@mui/material";

import { Props, State } from "./interfaces";
import { DialogContent } from "./styles";
import DialogTitle from "../../../../../../containers/DialogTitle/DialogTitle";
import DialogActions from "../../../../../../containers/DialogActions/DialogActions";
import { STOModel } from "../../../../../../models/base/sto-model";
import { toastifyResponse } from "../../../../../../utils/toastify-response/toastify-response";
import { saveBankTransaction } from "../../../../../../services/bank-transaction/bank-transaction-api.service";
import { saveCashTransaction } from "../../../../../../services/cash-transaction/cash-transaction-api.service";
import { BankTransactionDTO } from "../../../../../../models/bank-transaction/bank-transaction-dto";
import { CashTransactionDTO } from "../../../../../../models/cash-transaction/cash-transaction-dto";
import { DeleteButton } from "../../../../../../reusable-components/Table/RemoveItem/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
const UnlinkTransaction = ({ currItem, item, serviceApiInstance, handleReload, buttonType = "icon" }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.link_amount";

  const [state, setState] = useState<State>({
    openDialog: false,
    loading: false,
    error: "",
  });

  const setOpenDialog = (value: boolean) => setState((state) => ({ ...state, openDialog: value }));

  const handleCloseDialog = () => {
    setState((state) => ({
      ...state,
      error: "",
      openDialog: false,
    }));
  };

  const handleSave = async () => {
    setState((state) => ({ ...state, loading: true }));

    const currTransactionIdx = currItem.transactions.findIndex((transaction) => transaction.id === item.id);

    const transactionsArray = [...currItem.transactions];

    transactionsArray.splice(currTransactionIdx, 1);

    const resultItem = { ...currItem, transactions: transactionsArray };

    try {
      const { error } = currItem.hasOwnProperty("bankAccount")
        ? await saveBankTransaction({
            ...(resultItem as BankTransactionDTO),
          })
        : await saveCashTransaction({
            ...(resultItem as CashTransactionDTO),
          });

      if (!error) {
        setState((state) => ({ ...state, openDialog: false }));

        handleReload();
      }
    } catch (error) {
      setState((state) => ({ ...state, error: error as string }));
    } finally {
      setState((state) => ({ ...state, loading: false }));
    }
  };

  const deleteItem = async () => {
    let toSave: STOModel = { ...item };
    toSave = { ...item, isDeleted: true };

    const response = await serviceApiInstance.saveItems([toSave]);

    if (!response.error) {
      await handleReload();
    }

    toastifyResponse(response);
  };

  const setInitialData = useCallback(() => {
    setState((state) => ({
      ...state,
    }));
  }, []);

  useEffect(() => {
    setInitialData();
    return () => {
      setState({
        openDialog: false,
        loading: false,
        error: "",
      });
    };
  }, [setInitialData]);

  return (
    <>
      {buttonType === "icon" ? (
        <Button
          color="error"
          onClick={() => setOpenDialog(true)}
        >
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      ) : (
        <DeleteButton
          onClick={() => setOpenDialog(true)}
          buttonText={true}
        >
          {`${t(`buttons.delete`)}`}
        </DeleteButton>
      )}

      <Dialog
        open={state.openDialog}
        onClose={handleCloseDialog}
        fullWidth
      >
        <DialogTitle
          title={""}
          handleClose={handleCloseDialog}
        />
        <DialogContent>
          <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <span style={{ fontWeight: "bold" }}>Do you want to unlink or to delete transaction?</span>
          </div>
        </DialogContent>
        <DialogActions
          handleCancel={handleCloseDialog}
          handleSave={handleSave}
          customSaveName={"Unlink"}
          handleDelete={deleteItem}
          canBeDeleted={true}
          loading={state.loading}
          error={state.error}
        />
      </Dialog>
    </>
  );
};

export default UnlinkTransaction;
